import { Component, OnInit, Input} from "@angular/core";
import { Router, ActivatedRoute } from '@angular/router';
import { CaseSearchInput } from "../app.entities";
import { AppService } from "../app.service";
declare global {
    interface Window {
        dataLayer: any;
    }
}

@Component({
    selector: "case-search",
    templateUrl: "./casesearch.component.html"
})
export class CaseSearchComponent implements OnInit {

    model = new CaseSearchInput();
    submitted = false;
    showError = false;
    errorMessage = '';   
    key: string;

    constructor(
        private caseLookupService: AppService,
        private router: Router,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.route.queryParams.subscribe(queryParams => {
            const key = queryParams["key"];
            if (typeof (key) !== "undefined") {
                this.key = key;
                this.navigateToCaseDetails(key);
            }
            else {
                this.router.navigate([`/support/case-lookup`]);
            }
        });       
    }

    navigateToCaseDetails(caseKey: string): void {  
        const encodedKey = encodeURIComponent(caseKey);
    window.location.href = `/support/case-lookup/case-details?key=${encodedKey}`;
    }

    handleError(error: any): void {        
        this.submitted = false;
        this.showError = true;
        if (typeof (error.error.exceptionMessage) != 'undefined' && error.error.exceptionMessage.indexOf("No Case was found") > -1)
        {
            this.errorMessage = "No Case was found for the Case Number and Email address provided";
        }
        else
        {
            console.log(error.error.exceptionMessage);
            this.errorMessage = "Error occurred while looking up the case";
        }        
    }

    onSubmit(): void {
        this.submitted = true;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'case_lookup_submitted'
        });
        this.caseLookupService
            .searchForCaseKey(this.model)
            .subscribe(
                key => this.navigateToCaseDetails(key),
                error => this.handleError(error)
            );
    }

}



// WEBPACK FOOTER //
// ./src/ts/Apps/CaseLookup/src/app/case-search/casesearch.component.ts